/**
 * @desc Names of the message-bus events.
 * @example
 * import * as MESSAGE_BUS_EVENTS from 'constants/message-bus-events';
 * console.log( MESSAGE_BUS_EVENTS.SOME_EVENT );
 */

// DOM operation events
export const DOM_EVENTS = {
    BODY_LOCK_SCROLL: 'DOM_BODY_LOCK_SCROLL'
};

// page level preloader events
export const SHOW_PAGE_LEVEL_PRELOADER = 'SHOW_PAGE_LEVEL_PRELOADER';
export const HIDE_PAGE_LEVEL_PRELOADER = 'HIDE_PAGE_LEVEL_PRELOADER';

// popover events
export const OPEN_POPOVER = 'OPEN_POPOVER';
export const UPDATE_POPOVER = 'UPDATE_POPOVER';
export const CLOSE_POPOVER = 'CLOSE_POPOVER';

// overlay evenets
export const OPEN_OVERLAY = 'OPEN_OVERLAY';
export const UPDATE_OVERLAY = 'UPDATE_OVERLAY';
export const CLOSE_OVERLAY = 'CLOSE_OVERLAY';

// tooltip evenets
export const OPEN_TOOLTIP = 'OPEN_TOOLTIP';
export const UPDATE_TOOLTIP = 'UPDATE_TOOLTIP';
export const CLOSE_TOOLTIP = 'CLOSE_TOOLTIP';

// force scroller
export const RELOAD_FORCE_SCROLLER = 'RELOAD_FORCE_SCROLLER';

// successful checkout
export const SHOW_CHECKOUT_SUCESS_VIEW = 'SHOW_CHECKOUT_SUCESS_VIEW';
export const SHOW_EPOST_JOURNEY_SUCCESS_VIEW = 'SHOW_EPOST_JOURNEY_SUCCESS_VIEW';

// successful checkout
export const SHOW_PAY_BALANCE_SUCESS_VIEW = 'SHOW_PAY_BALANCE_SUCESS_VIEW';

// google map events
export const GOOGLE_MAP_FOCUS_LOCATION = 'GOOGLE_MAP_FOCUS_LOCATION';

// memeber management page
export const MEMBER_MANAGEMENT_REFRESH = 'MEMBER_MANAGEMENT_REFRESH';
export const ORDER_DETAIL_REFRESH = 'ORDER_DETAIL_REFRESH';
export const CHOIOCE_LIST_UPDATED = 'CHOIOCE_LIST_UPDATED';
export const CALL_ENDED = 'CALL_ENDED';

// websocket events
export const WIDGET_RELOAD_REQUEST = 'RELOAD';
export const WIDGET_SYNC_REQUEST = 'SYNC';

// flyout events
export const ADD_TO_FLYOUT = 'ADD_TO_FLYOUT';
export const UPDATE_FLYOUT = 'UPDATE_FLYOUT';
